// I suspect this is not fully robust, but its good enough
// for the simple use cases we have
const extensionUrlFunction = (extension: string) => {
  const regex = new RegExp(`(\\.${extension})?(\\?.*)?$`);
  const replacement = `.${extension}$2`;
  return (url: string) => url.replace(regex, replacement);
};

// This can be done with the Accept header, but I sometimes use the same exact
// path for getting JSON and HTML and browsers cache the result based just on
// the url for some reason. That can mean hitting the back button to return to a
// page that both loaded and made an async request from the same url will show
// the users the cached response from the async request instead of the page.
export const jsonUrl = extensionUrlFunction('json');

export const csvUrl = extensionUrlFunction('csv');
